import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./WarehouseBackupForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelAssignWarehouseBackup} from "../../../actions/InventoryApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "backupWarehouseId");

  return errors.toJS();
}

class AssignWarehouseBackupFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("id", this.props.id);
    return this.props.assignWarehouseBackup(updatedValues.toJS())
      .then((response) => {
        if (response.data.assignWarehouseBackup.errors.length <= 0) {
          this.props.cancelAssignWarehouseBackup();
        } else {
          let errors = createValidationErrors(response.data.assignWarehouseBackup.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAssignWarehouseBackup();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let warehouse = fromJS(data.warehouse);
    let warehouses = fromJS(data.warehouses);

    let initialValues = Map({
      backupWarehouseId: warehouse.get("backupWarehouseId"),
    })

    return (
      <Form
        initialValues={initialValues}
        warehouses={warehouses}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ASSIGN_WAREHOUSE_BACKUP = gql`
  mutation assignWarehouseBackup($data: WarehouseBackupInput!) {
    assignWarehouseBackup(input: $data) {
      errors { key message }
    }
  }
`;

const GET_WAREHOUSES = gql`
  query warehouseAndWarehouses($warehouseId:ID!) {
    warehouses {
      id
    }
    warehouse(warehouseId:$warehouseId) {
      backupWarehouseId
    }
  }
`;

const withQueries = compose(
  graphql(GET_WAREHOUSES, {
    options: (props) => ({
      variables: {
        warehouseId: props.id
      }
    })
  }),
  graphql(ASSIGN_WAREHOUSE_BACKUP, {
    props: ({ mutate }) => ({
      assignWarehouseBackup: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelAssignWarehouseBackup})(withQueries(AssignWarehouseBackupFormContainer));